var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.826,
    height: 25.875,
    viewBox: "0 0 13.826 25.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 3.401,
    height: 2.487,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29026",
    "data-name": "Group 29026",
    transform: "translate(-621.655 -414.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M196.808,138.859h-3.257a3.806,3.806,0,0,0-.921,2.765,4.536,4.536,0,0,1,.542-.519.06.06,0,0,1,.1.058c-.058.372-.008,1.488,1.912,3.383,1.92-1.9,1.97-3.011,1.912-3.383a.06.06,0,0,1,.1-.058,4.536,4.536,0,0,1,.542.519,3.806,3.806,0,0,0-.921-2.765",
    transform: "translate(433.4 295.399)",
    fill: "#f3a05e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M194.087,133.719l.237.457a.587.587,0,0,0,.521.317h3.142a.587.587,0,0,0,.521-.317l.237-.457Z",
    transform: "translate(432.144 299.792)",
    fill: "#023d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M189.472,127.761l.305.588a.755.755,0,0,0,.671.408h4.047a.755.755,0,0,0,.671-.408l.305-.588Z",
    transform: "translate(436.088 304.884)",
    fill: "#023d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M208.707,81.917l5.3,4.855-.128,5.565s-5.859-6.487-7.308-6.019Z",
    transform: "translate(421.475 344.063)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M167.911,81.917l-5.3,4.855.128,5.565s5.859-6.487,7.308-6.019Z",
    transform: "translate(459.042 344.063)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M189.321,27.57h0l-.068-.174a10.156,10.156,0,0,0-4.942-.046l-.087.22h0c-2.257,5.843-1.234,12.186-.871,13.976a.619.619,0,0,0,.607.5h5.623a.619.619,0,0,0,.607-.5c.363-1.791,1.386-8.133-.871-13.976",
    transform: "translate(441.784 390.935)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M199.18,49.474a2.094,2.094,0,1,1-2.094-2.094,2.094,2.094,0,0,1,2.094,2.094",
    transform: "translate(431.37 373.579)",
    fill: "#053146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.094,
    cy: 2.094,
    r: 2.094,
    transform: "translate(626.362 420.959)",
    fill: "none",
    stroke: "#424242",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M202.275,53.034a1.6,1.6,0,1,1-1.6-1.6,1.6,1.6,0,0,1,1.6,1.6",
    transform: "translate(427.884 370.116)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.602,
    cy: 1.602,
    r: 1.602,
    transform: "translate(626.955 421.548)",
    fill: "none",
    stroke: "#424242",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M201.653,52.453a1.587,1.587,0,1,1-1.587-1.587,1.587,1.587,0,0,1,1.587,1.587",
    transform: "translate(428.39 370.6)",
    fill: "#377864"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(626.724 421.321)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M200.166,51.134a1.585,1.585,0,0,1,1.427.9,1.586,1.586,0,1,0-2.955,1.113,1.583,1.583,0,0,1,1.528-2.009",
    transform: "translate(-198.333 -50.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M200.166,51.134a1.585,1.585,0,0,1,1.427.9,1.586,1.586,0,1,0-2.955,1.113,1.583,1.583,0,0,1,1.528-2.009Z",
    transform: "translate(-198.333 -50.721)",
    fill: "none",
    stroke: "#424242",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M198.1,4.259A16.141,16.141,0,0,0,195.619,0V0a16.122,16.122,0,0,0-2.461,4.213,5.783,5.783,0,0,0,4.942.046",
    transform: "translate(432.939 414.071)",
    fill: "#ea555f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b106521eee114b95bf457745f040af78.svg";
export { ForwardRef as ReactComponent };